import { useToast } from 'vue-toastification'

const toast = useToast()

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)
    toast.success('Скопировано в буфер обмена.', { timeout: 2000 })
  } catch (error) {
    console.error('Не удалось скопировать текст:', error)
    toast.error('Не удалось скопировать текст.')
  }
}
